<template>
    <common-modal :width="'medium'" @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <div class="signup_invite_modal--container">
            <common-content-spacer height="huge">
                <div class="auth-sign-up-confirm-practice__svg-container">
                    <div class="auth-sign-up-confirm-practice__svg">
                        <svg>
                            <use xlink:href="#picture-logo" />
                        </svg>
                    </div>
                </div>
                <div class="signup_invite_modal">
                    <common-content-spacer height="small">
                        <p class="header">
                            {{ $t('forms.auth.register.modals.invite_admin.heading_mobile') }}
                        </p>
                        <p class="header">
                            {{ $t('forms.auth.register.modals.invite_admin.heading') }}
                        </p>
                    </common-content-spacer>
                </div>

                <form-wrapper @submit="handleFormSubmission()">
                    <common-content-spacer height="large">
                        <div class="signup_invite_modal">
                            <form-row>
                                <form-cell>
                                    <text-field
                                        :placeholder="$t('forms.auth.register.modals.email_field.placeholder')"
                                        :label="$t('forms.auth.register.modals.email_field.label')"
                                        :isRequired="true"
                                        :formData="data"
                                        :error="inviteError"
                                        class="signup_invite_modal__field"
                                        valuePath="inviteEmail"
                                        type="email"
                                        @change="change($event)"
                                    >
                                        <template v-if="inviteError" #error>
                                            {{ $t('pages.auth.invites.user_already_invited') }}
                                            <a @click="sendReminder">
                                                {{ $t('pages.auth.invites.send_reminder') }}
                                            </a>
                                        </template>
                                    </text-field>
                                </form-cell>
                            </form-row>
                        </div>
                        <div class="signup_invite_modal">
                            <footer>
                                <common-buttons>
                                    <common-button
                                        class="signup_invite_modal__button"
                                        :label="$t('forms.auth.register.modals.buttons.send_invite')"
                                        :isProcessing="isSending"
                                        type="primary"
                                        size="large"
                                    ></common-button>
                                </common-buttons>
                            </footer>
                        </div>
                    </common-content-spacer>
                </form-wrapper>
            </common-content-spacer>
        </div>
    </common-modal>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import UserRolesEnum from 'enums/UserRolesEnum'

    export default {
        mixins: [FormMixin],

        props: {
            inviteError: { type: String, default: '' },
            formData: { type: Object, default: undefined },
        },

        data() {
            return {
                isSending: false,
                UserRolesEnum: UserRolesEnum,
            }
        },

        methods: {
            handleFormSubmission() {
                this.isSending = true
                this.emitEvent({ name: 'admin-invited', payload: this.data.inviteEmail })
            },

            sendReminder() {
                this.emitEvent({ name: 'send-reminder', payload: this.data.inviteEmail })
            },
        },
    }
</script>
